import { useMutation } from '../';
import { newCustomPortalMutation } from '../mutations';

export function useNewCustomPortalMutation() {
  const { data, isLoading, mutate } = useMutation();

  const run = (variables, onFinish) => {
    mutate(newCustomPortalMutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
